<div class="diagnostics-container">
  <h2>Test Backend API Healthcheck</h2>
  <p>Result:</p>
  <ng-container *ngIf="healthCheck$ | async as healthcheck">
    <pre>{{ healthcheck | json }}</pre>
  </ng-container>
</div>
